import { ScreenSizes } from '@space-core/styles'

import type { GetSrcSetWebParams, GenerateSourceTagReturn } from './types'

export function generateSourceTag(type: string, srcSet: string): GenerateSourceTagReturn {
  return (
    <source
      type={type}
      media={`(max-width: ${ScreenSizes.sm})`}
      srcSet={srcSet}
      sizes={`sizes="(max-width: ${ScreenSizes.sm}) 100vw, (max-width: ${ScreenSizes.md}) 100vw, (max-width: ${ScreenSizes.lg}) 50vw, 33vw`}
    />
  )
}

export function getSrcSetWeb({ isPreview = false, slide }: GetSrcSetWebParams): string {
  if (isPreview) {
    return ''
  }

  const { imageUrlWebL2, imageUrlWebL3, imageUrlWebL4, imageUrlWebL5 } = slide

  if (!imageUrlWebL2 && !imageUrlWebL3 && !imageUrlWebL4 && !imageUrlWebL5) {
    return ''
  }

  return `${imageUrlWebL2} 1280w,
  ${imageUrlWebL3} 1440w,
  ${imageUrlWebL4} 1920w,
  ${imageUrlWebL5} 2560w,
  `
}
